import { gql } from '@apollo/client'

export default gql(`
query{
    listModuleSettings {
        items {
          id
          channelManagerSetting {
            masterConfigEnabled
            masterConfigSchemaId
          }
        }
      }
}`)
